export default __webpack_public_path__ + "static/brush-yellow-line-37b56e2f65e28d00687ac04004a41c39.png";